export default "__VITE_ASSET__6ccbac51__"